import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.54}
      d="m9.583 13.022 1.21 1.21c.089.089.24.081.321-.023l3.504-4.595"
    />
  </svg>
);
export const CheckIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
